import {
  XA_ACTIVE_TAB,
  XA_DELETE_AGENT_SUCCESS,
  XA_FETCH_AGENTS_POST,
  XA_FETCH_AGENTS_SUCCESS,
  XA_POLL_CONNECTION_STATUS_SUCCESS,
  XA_RESET,
  XA_SAVE_NAME_POST,
  XA_SAVE_NAME_SUCCESS,
  XA_SAVE_NAME_FAILURE,
  XA_UPDATE_AGENT_OWNERS_POST,
  XA_UPDATE_AGENT_OWNERS_SUCCESS,
  XA_UPDATE_AGENT_OWNERS_FAILURE,
  XA_UPDATE_AGENT_MONITORS_POST,
  XA_UPDATE_AGENT_MONITORS_SUCCESS,
  XA_UPDATE_AGENT_MONITORS_FAILURE,
} from '../../actions/xAgent';

import {
  deleteAgentSuccess,
  fetchAgentSuccess,
  pollConnectionStateSuccess,
  saveNameSuccess,
  updateAgentMonitorsSuccess,
  switchActiveTab,
} from './agentsStateUtility';

const INITIAL_STATE = {
  agents: [],
  filterStatus: 'SHOW_ALL',
};

export default function xAgentFetchDataReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case XA_FETCH_AGENTS_SUCCESS: {
      return fetchAgentSuccess(state, action);
    }
    case XA_POLL_CONNECTION_STATUS_SUCCESS: {
      return pollConnectionStateSuccess(state, action);
    }
    case XA_SAVE_NAME_SUCCESS: {
      return saveNameSuccess(state, action);
    }
    case XA_DELETE_AGENT_SUCCESS: {
      return deleteAgentSuccess(state, action);
    }
    case XA_UPDATE_AGENT_OWNERS_SUCCESS: {
      return {
        ...state,
        owners: action.payload.owners,
      };
    }
    case XA_FETCH_AGENTS_POST:
      return {
        ...state,
        filterStatus: action.filterStatus,
        showAllDetails: false,
      };
    case XA_ACTIVE_TAB: {
      return switchActiveTab(state);
    }
    case XA_SAVE_NAME_POST:
      return {
        ...state,
        updateError: undefined,
      };
    case XA_SAVE_NAME_FAILURE:
      return {
        ...state,
        updateError: action.payload.code,
      };
    case XA_UPDATE_AGENT_OWNERS_POST: {
      return {
        ...state,
        updateError: undefined,
      };
    }
    case XA_UPDATE_AGENT_OWNERS_FAILURE: {
      return {
        ...state,
        updateError: action.payload.code,
      };
    }
    case XA_UPDATE_AGENT_MONITORS_POST: {
      return {
        ...state,
        updateError: undefined,
      };
    }
    case XA_UPDATE_AGENT_MONITORS_SUCCESS: {
      return updateAgentMonitorsSuccess(state, action);
    }
    case XA_UPDATE_AGENT_MONITORS_FAILURE: {
      return {
        ...state,
        updateError: action.payload.code,
      };
    }
    case XA_RESET: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}
